import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import propShoe from '../../assets/haelo-show.jpg';
import './ProductCard.css';

const ProductCard = ({ image, price, store, productPage }) => {
  return (
    <div className="product_row">
      <div className="product_card">
        <Link to={productPage} className="product_link">
          <img src={image} alt="haelo shoe" />
          <div className="product_card_body">
            <p className="product_store">#{store}</p>
            <p className="product_price">${price}</p>
          </div>
        </Link>
      </div>

      <div className="product_card">
        <Link to={productPage} className="product_link">
          <img src={image} alt="haelo shoe" />
          <div className="product_card_body">
            <p className="product_store">#{store}</p>
            <p className="product_price">${price}</p>
          </div>
        </Link>
      </div>

      <div className="product_card">
        <Link to={productPage} className="product_link">
          <img src={image} alt="haelo shoe" />
          <div className="product_card_body">
            <p className="product_store">#{store}</p>
            <p className="product_price">${price}</p>
          </div>
        </Link>
      </div>

      <div className="product_card">
        <Link to={productPage} className="product_link">
          <img src={image} alt="haelo shoe" />
          <div className="product_card_body">
            <p className="product_store">#{store}</p>
            <p className="product_price">${price}</p>
          </div>
        </Link>
      </div>
    </div>
  );
};

ProductCard.propTypes = {
  image: PropTypes.string,
  store: PropTypes.string,
  price: PropTypes.string,
  productPage: PropTypes.string,
};

ProductCard.defaultProps = {
  image: propShoe,
  store: 'YBNLstore',
  price: 10.5,
  productPage: '/store/product',
};

export default ProductCard;
